<div class="pt-5 justify-content-center align-items-center">
  <hr>
  <!-- Header -->
  <div class="text-center mb-4">
    <h1 class="text-dark">Solver</h1>
    <div class="text-muted fs-6">
      Solver is an AI-powered tool that leverages cutting-edge models like Google Gemini and other large language models (LLMs) to analyze and provide solutions and explanations for exercises captured in photos of physical documents or any images containing text-based exercises.
    </div>
  </div>
  <hr>

  <!-- Header -->
  <div class="text-center mb-4">
    <h1 class="text-dark">How to use</h1>
    <div class="text-muted fs-6">
      In just two steps, your AI-generated solutions and explanations appear instantly on the screen.
    </div>
  </div>

  <!-- How to Use Section -->
  <div class="row g-4">
    <!-- Feature 1: Take a Photo -->
<!--    <div class="col-lg-4 col-12">-->
<!--      <h3><span class="badge text-bg-primary disabled rounded-3"> 1 </span> <span class="px-2 text-dark mt-3">Choose an Action</span></h3>-->
<!--      <div class=" text-start h-100 ">-->
<!--        <div class="">-->

<!--          <div class="text-muted fs-6"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Feature 2: Summarize -->
    <div class="col-lg-6 col-12">
      <h3><span class="badge text-bg-danger disabled rounded-3"> 1 </span> <span class="px-2 text-dark mt-3">Shoot a photo</span></h3>
      <div class=" text-start h-100 ">
        <div class="">
          <div class="text-muted fs-6">Use your mobile phone, laptop, or tablet to capture an image of a physical document with text, or upload a screenshot instead. Multiple images can be shot or uploaded.</div>
        </div>
      </div>
    </div>

    <!-- Feature 3: Print Output -->
    <div class="col-lg-6 col-12">
      <h3><span class="badge text-bg-danger disabled rounded-3"> 2 </span>  <span class="px-2 text-dark mt-3">Click the ✨ button </span></h3>
      <div class=" text-start h-100 ">
        <div class="">

          <div class="text-muted fs-6">Tap the ✨ button to see what it comes up with!</div>
        </div>
      </div>
    </div>

  </div>
  <hr>

</div>
